import { FC } from 'react';
import { Step } from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { TourGuide } from '../../../../components';

type TInviteTeamTour = {
  runTour: boolean
  setRunTour: (val: boolean) => void
  handleOpenNav: () => void
  handleCloseNav: () => void
};

interface ITourStep extends Step {
  skipStep?: boolean
}

const InviteTeamTour: FC<TInviteTeamTour> = ({
  runTour, setRunTour, handleOpenNav, handleCloseNav,
}) => {
  const { t } = useTranslation('tour');

  const tourSteps: Array<ITourStep> = [
    {
      target: '#language',
      disableBeacon: true,
      content: t('languageIcon'),
    },
    {
      target: '#skip-invite',
      disableBeacon: true,
      content: t('inviteSkipButton'),
    },
    {
      target: '#invite-members',
      disableBeacon: true,
      content: t('clickThisButtonToInvite'),
    },
    {
      target: '#add-member',
      disableBeacon: true,
      content: t('useThisButtonToOpenNavigation'),
    },
    {
      target: '#first-name',
      skipStep: true,
      disableOverlay: true,
      disableBeacon: true,
      content: t('inTheNavigation'),
    },
    {
      target: '#first-name',
      disableBeacon: true,
      content: t('enterTheFirstNameOfTheEmployee'),
    },
    {
      target: '#last-name',
      disableBeacon: true,
      content: t('enterTheLastNameOfTheEmployee'),
    },
    {
      target: '#invite-email',
      disableBeacon: true,
      content: t('enterAUniqueEmail'),
    },
    {
      target: '#invite-locations',
      disableBeacon: true,
      content: t('assignLocationsToThisUser'),
    },
    {
      target: '#invite-permissions',
      disableBeacon: true,
      content: t('setThePermissionLevel'),
    },
    {
      target: '#invite-add-button',
      disableBeacon: true,
      content: t('clickThisButtonToAddTheEmployee'),
    },
    {
      target: '#invite-add-more',
      disableBeacon: true,
      content: t('useThisButtonToSaveThisEmployee'),
    },
  ];

  const actions = new Map([
    [3, handleOpenNav],
  ]);

  const handleFinishTour = () => {
    setRunTour(false);
    handleCloseNav();
  };

  return (
    <TourGuide actions={actions} steps={tourSteps} run={runTour} onFinish={handleFinishTour} />
  );
};

export {
  InviteTeamTour,
};
